const SET_SHOW_DETAIL_GIFT_VOUCHER = 'SET_SHOW_DETAIL_GIFT_VOUCHER';
const SET_DETAIL_GIFT_VOUCHER = 'SET_DETAIL_GIFT_VOUCHER';
const SET_SHOW_LIST_GIFT_VOUCHER_MODAL = 'SET_SHOW_LIST_GIFT_VOUCHER_MODAL';

export default {
  SET_SHOW_DETAIL_GIFT_VOUCHER,
  SET_DETAIL_GIFT_VOUCHER,
  SET_SHOW_LIST_GIFT_VOUCHER_MODAL,
};
